import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUpdateDescriptionContentProps } from './msg-group-update-description-content';
import { MsgGroupUpdateDescriptionContent } from './msg-group-update-description-content';

export interface MsgGroupUpdateDescriptionPreviewProps
  extends MsgGroupUpdateDescriptionContentProps {}

export const MsgGroupUpdateDescriptionPreview = memo(function MsgGroupUpdateDescriptionPreview({
  message,
}: MsgGroupUpdateDescriptionPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUpdateDescriptionContent message={message} />
    </LastMessageSystem>
  );
});
